import type {ReactElement} from 'react';
import styles from '@Panels/stock-panel/components/stock-panel-no-results/stock-panel-no-results.module.scss';
import {Text, TextSize, TextType} from '@Components/text';
import {StockPanelMessage} from '@Panels/stock-panel/components/stock-panel-message/stock-panel-message';

export interface StockPanelNoResultsProps {
  className?: string;
  searchTerm: string;
  aiCta?: ReactElement;
}

export default function StockPanelNoResults({...props}: StockPanelNoResultsProps): ReactElement {
  const getMessageText = (): string => {
    if (props.searchTerm === '') {
      return window.i18next.t('pmwjs_we_couldnt_find_any_matching_results');
    }
    return window.i18next.t('pmwjs_we_couldnt_find_anything_for_search_term', {searchTerm: props.searchTerm});
  };

  return (
    <StockPanelMessage icon={props.searchTerm === '' ? 'icon-ban' : 'icon-search'} className={props.className}>
      <div className={`flex-v-row flex-center ${styles.copyBlock}`}>
        <Text className="content-body text-center" val={getMessageText()} type={TextType.BODY} size={TextSize.MD} />
      </div>
      {props.aiCta ?? null}
    </StockPanelMessage>
  );
}
